import { render } from "./OverviewModal.vue?vue&type=template&id=8aca85d0&scoped=true"
import script from "./OverviewModal.vue?vue&type=script&lang=js"
export * from "./OverviewModal.vue?vue&type=script&lang=js"

import "./OverviewModal.vue?vue&type=style&index=0&id=8aca85d0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aca85d0"],['__file',"src/scripts/view/review/modals/OverviewModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8aca85d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8aca85d0', __exports__)) {
    api.reload('8aca85d0', __exports__)
  }
  
  module.hot.accept("./OverviewModal.vue?vue&type=template&id=8aca85d0&scoped=true", () => {
    api.rerender('8aca85d0', render)
  })

}


export default __exports__